<template>
  <div class="carbonfootprint-certificate">
    <el-form
      v-for="(ruleForm, index) in formList"
      :ref="`ruleForm${index}`"
      :key="index"
      :model="ruleForm"
      :rules="rules"
      size="small"
      :disabled="type === 'detail'"
      label-width="110px"
      label-suffix=":"
    >
      <div class="certificate-title">
        <div class="certificate-title-text">其他{{ index + 1 }}</div>
        <eui-btn
          v-if="formList.length > 1 && componentType != 'single'"
          type="text"
          color="#E50113"
          @click="deleteCertificate(index)"
          >删除</eui-btn
        >
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="证书名称" prop="reportName">
            <el-input
              v-model="ruleForm.reportName"
              maxlength="50"
              placeholder="请输入证书名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="颁证机构" prop="institutionName">
            <el-input
              v-model="ruleForm.institutionName"
              maxlength="50"
              placeholder="请输入颁证机构"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="有效期" prop="validTime">
            <el-date-picker
              v-model="ruleForm.validTime"
              style="width: 100%"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            class="cursor-form-item"
            label="证书电子版/扫描件"
            prop="certAttachment"
          >
            <eui-upload
              ref="upload"
              :headers="headers"
              :file-list="ruleForm.certAttachment"
              :action="fileUrl"
              :auto-upload="autoUpload"
              :show-file-list="true"
              :limit="1"
              accept=".pdf,.jpg,.png"
              text="上传文件"
              :limit-file-size="30"
              tip="最多上传1个文件，格式为PDF、JPG、PNG，大小不超过30M"
              @handleSuccess="
                (res) => uploadSuccess(res, index, 'certAttachment')
              "
            ></eui-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="查询网址" prop="reportAddress">
            <el-input
              v-model="ruleForm.reportAddress"
              maxlength="50"
              placeholder="查询网址"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="componentType != 'single'" class="add-from">
      <eui-btn
        v-if="formList.length < 5"
        type="weak"
        icon="eicon-add"
        width="1160"
        size="40"
        icon-position="left"
        @click="addCertificate"
        >新增其他</eui-btn
      >
    </div>
    <!-- <el-button @click="submit">提交</el-button> -->
  </div>
</template>

<script>
import api from '@/modules/projectA/api/order';
import { epecToken } from '@/modules/projectA/utils/globalData';

export default {
  name: 'OtherList',
  components: {},
  props: {
    other: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    componentType: {
      type: String,
      default: '',
    },
  },
  data() {
    const uploadValidator = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error('请上传证书电子版/扫描件'));
      } else {
        callback();
      }
    };
    return {
      headers: epecToken,
      fileUrl: api.fileUploadForGreenPdfAndPic,

      autoUpload: true,
      formList: [
        {
          institutionName: '',
          reportName: '',
          validTime: [],
          reportAddress: '',
          certAttachment: [],
        },
      ],
      rules: {
        institutionName: [
          { required: true, message: '请输入颁证机构', trigger: 'blur' },
        ],
        reportName: [
          { required: true, message: '请输入证书名称', trigger: 'blur' },
        ],
        validTime: [
          { required: true, message: '请选择有效期', trigger: 'blur' },
        ],
        certAttachment: [
          {
            required: true,
            message: '请上传证书电子版/扫描件',
            trigger: 'blur',
            validator: uploadValidator,
          },
        ],
      },
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.userInfo;
      // return this.$cookies.get("isLogin")
    },
  },
  created() {
    if (this.other && this.other.length > 0) {
      this.formList = JSON.parse(
        JSON.stringify(
          this.other.map((item) => {
            if (item.validStart)
              item.validTime = [item.validStart, item.validEnd];
            if (item.certAttachmentUrl)
              item.certAttachment = [
                {
                  name: item.certAttachmentName,
                  url: item.certAttachmentUrl,
                },
              ];

            return item;
          })
        )
      );
    }
  },
  mounted() {
    const token = this.$cookies.get('epecToken');
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    if (token && this.userInfo && this.userInfo.companyId) {
      this.headers = {
        'epec-sso-token': this.$cookies.get('epecToken'),
        'epec-from': 'WEB_SITE',
        'epec-locale': 'ZH',
        'epec-company-id': this.userInfo.companyId,
      };
    }
  },
  methods: {
    uploadSuccess(res, index, key) {
      console.log(res);
      if (res.success) {
        this.formList[index][key] = [
          {
            ...res.data,
            name: res.data.fileName,
            url: res.data.url,
          },
        ];
      }
    },
    deleteCertificate(index) {
      this.formList.splice(index, 1);
    },
    addCertificate() {
      this.formList.push({
        institutionName: '',
        reportName: '',
        validTime: [],
        reportAddress: '',
        certAttachment: [],
      });
    },

    submit() {
      return new Promise((resolve, reject) => {
        const validatePromises = this.formList.map((_, index) => {
          // 注意 v-for 下的 ref 是数组，所以要 [0]
          return this.$refs[`ruleForm${index}`][0].validate();
        });

        Promise.all(validatePromises)
          .then(() => {
            console.log('✅ 全部验证通过', this.formList);
            const params = this.getParams();
            // 这里写提交接口
            resolve({
              success: true,
              data: params,
            });
          })
          .catch(() => {
            reject();
            console.log('❌ 有表单没通过验证--report');
          }); // 把所有表单的 validate() 都转成 Promise
      });
    },
    getParams() {
      return this.formList.map((_) => {
        // validTime
        _.validStart = _.validTime && _.validTime[0];
        _.validEnd = _.validTime && _.validTime[1];
        _.certAttachmentUrl =
          _.certAttachment && _.certAttachment[0] && _.certAttachment[0].url;
        _.certAttachmentName =
          _.certAttachment && _.certAttachment[0] && _.certAttachment[0].name;
        return _;
      });
    },
    save() {
      return this.getParams();
    },
  },
};
</script>

<style lang="scss" scoped>
.certificate-title {
  width: 100%;
  height: 34px;
  margin-bottom: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(217, 217, 217, 1);
  .certificate-title-text {
    position: relative;
    font-size: 14px;
    line-height: 24px;
    // font-family: PingFangSC-Medium;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    padding-left: 10px;
    z-index: 2;
    &::before {
      content: '';
      position: absolute;
      top: 0px;
      left: 0px;
      width: 80px;
      height: 24px;
      background: linear-gradient(
        90deg,
        rgba(102, 171, 254, 0.5) 0%,
        rgba(73, 151, 246, 0) 100%
      );
      z-index: -1;
    }
  }
}
.add-from {
  margin-top: 10px;
}
::v-deep.el-form-item {
  .el-form-item__label {
    padding: 0px;
    padding-right: 10px;
    color: #666;
  }
  .el-form-item__label:after {
    content: '';
    display: none;
  }
}
::v-deep.el-form-item.cursor-form-item {
  .el-form-item__label {
    line-height: 1;
  }
}
::v-deep.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
::v-deep.el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: '*';
  color: rgba(240, 37, 15, 1);
  margin-right: 0px !important;
  /* margin-right: 4px; */
}
::v-deep.el-form .el-input__inner,
::v-deep.el-form .el-input,
::v-deep.el-form .el-date-editor,
::v-deep.el-form .el-select .el-input__inner,
::v-deep.el-form .el-select .el-input__inner,
::v-deep.el-input--small .el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}
::v-deep.el-radio {
  margin-right: 0px;
}
::v-deep.remark {
  padding-left: 0px !important;
}
::v-deep.el-radio__label {
  color: #333;
}
::v-deep.el-radio__input.is-checked + .el-radio__label {
  color: #333;
}
</style>
